import { globalTypes } from '../types';
import { reduceAction } from '../helpers';

import types from './types';

export const initialState = () => ({
    guid: '',
    code: '',
    loading: false,
    loaded: false,
    isEmpty: true,
    updated: false,
    removed: false,
    hasLowStock: false,
    lowStockItems: [],
    loadingCodes: [],
    haveOutOfStock: false,
    stockValidation: true,
    limitativeBrands: [],
    overlimitedBrands: [],
    isLimitativeBrandsReady: false,
    adjustedCartData: {},
    isProductsBeenMerged: false,
    minicartCount: 0,
    egiftCardCartActive: false,
    egiftCardCode: '',
    regularCartId: '',
    checkLimitativeBrands: true,
    gwpItems: [],
    selectedGwpItem: {},
    voucherIsLoading: false,
    loyaltyChequesMessage: {},
    homeDeliveryDate: '',
    ccExpressDate: '',
    ccDate: '',
    postPointDate: '',
    addToCardError: false,
    removeFromCartError: false,
    maxAllowedProductExceeded: false,
});

const updateLoadingData = (state, { loading, code }) => {
    const index = state.loadingCodes.findIndex(_code => _code === code);

    if (loading) {
        if (index === -1) {
            state.loadingCodes.push(code);
        }
    } else if (index !== -1) {
        state.loadingCodes.splice(index, 1);
    }
};

const reducers = (state = initialState(), action) => {
    const data = action && action.payload;

    switch (action.type) {
        case types.INITIALIZE:
        case globalTypes.INITIALIZE:
            return initialState();

        case types.SET_LOADING:
            updateLoadingData(state, data);
            return { ...state, loading: !!data.loading };

        case types.SET_CODE:
            return reduceAction(state, 'code', action.payload);

        case types.SET_REGULAR_CART_ID:
            return reduceAction(state, 'regularCartId', action.payload);

        case types.SET_EGIFT_CARD_CODE:
            return reduceAction(state, 'egiftCardCode', action.payload);

        case types.SET_EGIFTCARD_CART_ACTIVE:
            return reduceAction(state, 'egiftCardCartActive', action.payload);

        case types.SET_GUID:
            return reduceAction(state, 'guid', action.payload);

        case types.SET_STOCK_VALIDATION:
            return reduceAction(state, 'stockValidation', action.payload);

        case types.SET_HAVE_OUT_OF_STOCK:
            return reduceAction(state, 'haveOutOfStock', action.payload);

        case types.SET_OUT_OF_STOCK_ENTRIES_NUMBER:
            return reduceAction(state, 'outOfStockEntriesNumber', action.payload);

        case types.SET_CART_DATA:
            return {
                ...state,
                code: data.code,
                guid: data.guid,
                isEmpty: !(data.entries && data.entries.length),
                data: {
                    ...state.data,
                    ...data,
                    deliveryAddress: data.deliveryAddress || {},
                    paymentAddress: data.paymentAddress || {},
                },
                minicartCount:
                    (data.totalUnitCount || 0) -
                    (data.totalSamplesCount || 0) -
                    (data.gwpQuantity || 0),
            };

        case types.SET_DATA_ATTR:
            return {
                ...state,
                data: { ...state.data, [data.name]: data.value },
            };

        case types.UPDATE_CART_COMPLETE:
            return reduceAction(state, 'updated', action.payload);

        case types.SET_LOADED:
            return reduceAction(state, 'loaded', action.payload);

        case types.REMOVE_ITEM_COMPLETE:
            return reduceAction(state, 'removed', !!action.payload);

        case types.REMOVE_ITEM_RESET:
            return reduceAction(state, 'removed', false);

        case types.SET_HAS_LOW_STOCK: {
            return reduceAction(state, 'hasLowStock', action.payload);
        }
        case types.CLEAR_HAS_LOW_STOCK: {
            return reduceAction(state, 'hasLowStock', false);
        }
        case types.SET_LOW_STOCK_ITEMS:
            return {
                ...state,
                lowStockItems: [...state.lowStockItems, action.payload],
            };

        case types.REMOVE_FROM_LOW_STOCK_ITEMS:
            return {
                ...state,
                lowStockItems: [...state.lowStockItems.filter(i => i !== action.payload)],
            };

        case types.FORCE_OUT_OF_STOCK:
            return reduceAction(state, 'forceOutOfStock', data.code);

        case types.STOCK_LEVEL_LIST: {
            return {
                ...state,
                stockLevelList: {
                    ...state.stockLevelList,
                    ...action.payload,
                },
            };
        }
        case types.DELETE_STOCK_LEVEL_LIST: {
            const { stockLevelList, ...withoutStockList } = state;
            return stockLevelList ? withoutStockList : state;
        }
        case types.CLEAR_DELIVERY_ADRESS: {
            return {
                ...state,
                data: { ...state.data, deliveryAddress: {} },
            };
        }
        case types.SET_ADJUSTED_CART_DATA: {
            const {
                adjustedCartEntries,
                adjustedOutOfStockEntries,
                isAdjustedCartEntriesPlural,
                isOutOfStockEntriesPlural,
                hasForbiddenStock,
                hasOnlyForbiddenEntryInCart,
                forbiddenStockPayload,
            } = action.payload;

            return {
                ...state,
                adjustedCartData: {
                    adjustedCartEntries,
                    adjustedOutOfStockEntries,
                    isAdjustedCartEntriesPlural,
                    isOutOfStockEntriesPlural,
                    hasForbiddenStock,
                    hasOnlyForbiddenEntryInCart,
                    forbiddenStockPayload,
                },
            };
        }
        case types.RESET_ADJUSTED_CART_DATA: {
            return {
                ...state,
                adjustedCartData: {
                    adjustedCartEntries: [],
                    adjustedOutOfStockEntries: [],
                    isAdjustedCartEntriesPlural: false,
                    isOutOfStockEntriesPlural: false,
                    hasForbiddenStock: false,
                    hasOnlyForbiddenEntryInCart: false,
                    forbiddenStockPayload: {},
                },
            };
        }
        case types.SET_LIMITATIVE_BRANDS: {
            return {
                ...state,
                limitativeBrands: action.payload,
                isLimitativeBrandsReady: true,
            };
        }
        case types.RESET_LIMITATIVE_BRANDS: {
            return {
                ...state,
                limitativeBrands: [],
                isLimitativeBrandsReady: false,
            };
        }
        case types.CHECK_LIMITATIVE_BRANDS:
            return reduceAction(state, 'checkLimitativeBrands', action.payload);

        case types.SET_OVERLIMITED_BRANDS:
            return reduceAction(state, 'overlimitedBrands', action.payload);

        case types.SET_IS_PRODUCTS_BEEN_MERGED:
            return reduceAction(state, 'isProductsBeenMerged', action.payload);

        case types.PERSIST_GWP_PRODUCT_CODES:
            return {
                ...state,
                gwpItems: { gwpItems: action.payload, maxSelectableQty: 1 },
            };

        case types.UPDATE_SELECTED_GWP_ITEM:
            return reduceAction(state, 'selectedGwpItem', action.payload);

        case types.VOUCHER_IS_LOADING:
            return reduceAction(state, 'voucherIsLoading', action.payload);

        case types.SET_LOYALTY_CHEQUES_MESSAGE:
            return reduceAction(state, 'loyaltyChequesMessage', action.payload);

        case types.SET_HOME_DELIVERY_DATE:
            return reduceAction(state, 'homeDeliveryDate', action.payload);

        case types.SET_CLICK_AND_COLLECT_EXPRESS_DELIVERY_DATE:
            return reduceAction(state, 'ccExpressDate', action.payload);

        case types.SET_CLICK_AND_COLLECT_TRADITIONAL_DELIVERY_DATE:
            return reduceAction(state, 'ccDate', action.payload);

        case types.SET_POST_POINT_DELIVERY_DATE:
            return reduceAction(state, 'postPointDate', action.payload);

        case types.REMOVE_BILLING_ADDRESS_SUCCESS:
            return {
                ...state,
                data: { ...state.data, paymentAddress: {} },
            };

        case types.SET_TEMPORARY_ADDRESS:
            return {
                ...state,
                data: { ...state.data, temporaryAddress: {} },
            };

        case types.SET_ADD_TO_CART_ERROR:
            return reduceAction(state, 'addToCardError', action.payload);

        case types.SET_REMOVE_FROM_CART_ERROR:
            return reduceAction(state, 'removeFromCartError', action.payload);

        case types.SET_DELIVERY_ADDRESS:
            return {
                ...state,
                data: { ...state.data, deliveryAddress: action.payload },
            };

        case types.SET_PAYMENT_ADDRESS:
            return {
                ...state,
                data: { ...state.data, paymentAddress: action.payload },
            };

        case types.SET_MAX_ALLOWED_PRODUCT_EXCEEDED:
            return {
                ...state,
                maxAllowedProductExceeded: action.payload,
            };

        case 'criteo.SET_CRITEO_DATA':
            return {
                ...state,
                placementBeaconFired: [],
                placements: data.placements,
                positions: data.positions,
                resolution: data.resolution,
                bannerPosition: data.bannerPosition,
                item: data.item,
            };

        default:
            return state;
    }
};

export default reducers;
